<template>
  <div class="com-item-page">
    <List
      :url="url"
      :method="method"
      :params="params"
      :on-getdata="onGetdata"
      :on-formatter="onFormatter"
      :showText="false"
      ref="list"
    >
      <ul slot="item">
        <li v-for="(item,index) in comments" :key="index">
          <div class="evaluate-top">
            <img :src="item.avatar" />
            <div class="evaluate-t-left">
              <div class="info">
                <p v-if="item.user_name">{{item.user_name}}</p>
                <p v-if="item.nickname">{{item.nickname}}</p>
                <van-rate v-model="item.grade" color="#EA7A2F" void-color="#EA7A2F" readonly />
                <p
                  class="times"
                  v-if="show_time"
                >{{item.created_at | fomartTime('yyyy-MM-dd hh:mm')}}</p>
                <p class="times" v-else>{{item.created_at}}</p>
              </div>
              <div class="com-label" v-if="item.tag_content">
                <span v-for="(it,idx) in item.tags" :key="idx">{{it}}</span>
              </div>
              <div class="evaluate-btom">{{item.content}}</div>
            </div>
          </div>
        </li>
      </ul>
    </List>
    <empty :empty_type="emptyType" v-if="comments.length == 0"></empty>
  </div>
</template>

<script>
import empty from "./Empty";
import List from "@/components/List";
export default {
  name: "CommentItem",
  components: {
    empty,
    List
  },
  data() {
    return {
      id: this.$route.query.id,
      comments: [],
      emptyType: {
        name: "暂无评论"
      },
      url: "",
      params: {},
      method: "post",
      show_time: 0
    };
  },
  methods: {
    onGetdata(data) {
      this.comments = data;
    },
    onFormatter(data) {
      data.forEach(item => {
        if (item.tag_content) {
          item.tags = item.tag_content.split(",");
        }
      });
    }
  },
  created() {
    if (document.URL.search("teacher") > -1) {
      this.url = "/api/app/teacher/comment";
      this.params = {
        teacher_id: this.id
      };
    } else if (document.URL.search("book-detail") > -1) {
      this.url = `/api/app/book/comments/${this.id}`;
      this.method = "get";
      this.show_time = 1;
    } else {
      this.url = "/api/app/courseComment";
      this.params = {
        id: this.id
      };
      this.show_time = 1;
    }
  },
  mounted() {
    this.$refs.list.onLoad();
  }
};
</script>

<style lang="scss" scoped>
li {
  padding: 20px 20px;
}
.evaluate-top {
  display: flex;
  border-bottom: 1px solid #f1f1f1;
  &:last-child {
    border: 0;
  }
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .evaluate-t-left {
    flex: 1;
    .info {
      display: flex;
      padding-left: 20px;
      height: 50px;
      align-items: center;
      p {
        &:nth-child(1) {
          font-size: 28px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
      .van-rate {
        margin-left: 20px;
        height: 100%;
        box-sizing: border-box;
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        .van-rate__icon {
          font-size: 24px;
        }
      }
      .times {
        flex: 1;
        font-size: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        text-align: right;
      }
    }
  }
}
.com-label {
  padding-top: 10px;
  span {
    display: inline-block;
    width: 176px;
    height: 44px;
    line-height: 44px;
    background: #f5f5f5;
    border-radius: 8px;
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(140, 140, 140, 1);
    text-align: center;
    margin-left: 20px;
    margin-bottom: 10px;
  }
}
.evaluate-btom {
  padding-top: 10px;
  line-height: 48px;
  font-size: 24px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-left: 20px;
}
</style>
